import React from 'react'

import { TWidgetSettings, WidgetType } from 'types/GlobalWidget'
import { WidgetTagObject } from 'types/GlobalWidgetTag'
import { TFunction } from 'language/translator'
import { AiIconTip } from 'components_new/molecules/IconTip'

export const getIconName = (index: number, settings: TWidgetSettings) => {
  const type = settings.type.selected
  const segmentType = settings.segment_by.type

  switch (type) {
  case WidgetType.BAR_CHART:
    return 'SignalCellularAltOutlined'
  case WidgetType.LINE_CHART:
    return 'ShowChartOutlined'
  case WidgetType.LIST:
    return 'VerticalSplitOutlined'
  case WidgetType.BUBBLE_CHART:
    if (index === 0) {
      return 'BorderBottomOutlined'
    } else if (index === 1) {
      return 'BorderLeftOutlined'
    } else {
      return 'BubbleChartOutlined'
    }
  case WidgetType.COMBO_CHART:
    if (index === 0) {
      return 'BarChartTwoTone'
    } else {
      if (segmentType === 'DATE') {
        return 'ShowChartTwoTone'
      }

      return 'WorkspacesTwoTone'
    }
  case WidgetType.KEY_FIGURE: {
    return 'OneKOutlined'
  }
  case WidgetType.PIE_CHART: {
    return 'PieChart'
  }
  case WidgetType.MAP: {
    return 'MapOutlined'
  }
  default:
    return 'CalendarViewWeekOutlined'
  }
}

export const getAddTitle = (
  settings: TWidgetSettings,
  numberOfKpis: number,
  t: TFunction
) => {
  const type = settings.type.selected
  const segmentType = settings.segment_by.type

  if (type === WidgetType.BUBBLE_CHART) {
    if (numberOfKpis === 1) {
      return t('widgets', 'add_y_axis')
    }

    if (numberOfKpis === 2) {
      return t('widgets', 'add_radius')
    }
  }

  if (type === WidgetType.COMBO_CHART) {
    if (segmentType === 'DATE') {
      return t('widgets', 'add_line')
    }

    return t('widgets', 'add_points')
  }

  return t('widgets', 'add_metric')
}

export const getTagOptions = (
  tags: {
    selected: WidgetTagObject[]
    options: {
      id: string
      name: string
      ai_generated: boolean
    }[]
  },
  t: TFunction
) => {
  const newOptions = tags.options.map((tag) => ({
    id: tag.id,
    endAdornment: tag.ai_generated ? (
      <AiIconTip title={t('global', 'ai_generated')} />
    ) : undefined,
    title: tag.name,
    disabled: !!tags.selected.find((t) => {
      return t.tag_option_id === tag.id
    })
  }))

  return newOptions
}
